const DEFAULT_APP_NAMESPACE = 'no-eika-kredittbank';

export default DEFAULT_APP_NAMESPACE;
